export default {"src":"/_next/static/media/NVST.e1cfd5f8.svg","height":18,"width":18};